WYATT.registerComponent(
  "wyatt-modal",
  class WyattModal extends HTMLElement {
    connectedCallback() {
      this.openButton = this.querySelector("[data-modal-open]");
      this.dialog = this.getModal();
      this.closeButtons = this.dialog.querySelectorAll("[data-close]");
      this.wrapper = this.dialog.querySelector("[data-modal-wrapper]");

      document.querySelector("body").append(this.dialog);

      this.openButton.addEventListener("click", this.open.bind(this));

      this.handleClickOutside();

      this.dialog.addEventListener("close", () => {
        WYATT.toggleScrollLock("remove");
      });

      this.closeButtons.forEach((button) => {
        button.addEventListener("click", this.handleClose.bind(this));
      });
    }

    disconnectedCallback() {
      this.dialog.remove();
    }

    open() {
      this.dialog.showModal();
      WYATT.toggleScrollLock("add");
      this.triggerEvent("modalOpen");
    }

    handleClickOutside() {
      this.dialog.addEventListener("click", () => {
        this.dialog.close();
        this.triggerEvent("modalClose");
      });
      this.wrapper.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    }

    handleClose(event) {
      event.preventDefault();
      this.dialog.close();
      this.triggerEvent("modalClose");
    }

    getModal() {
      return (
        this.querySelector("[data-modal]") ||
        document.querySelector(this.openButton.dataset.modalOpen)
      );
    }

    triggerEvent(eventName) {
      const event = new CustomEvent(eventName);

      this.dialog.dispatchEvent(event);
    }
  }
);
